export const FormatMinutesTimePicker = (time: string): number => {
    const parts = time.split(':');
    let minutes = 0;
    switch (parts.length) {
        case 1:
            minutes += parseInt(parts[0]);
            break;
        case 2:
            minutes += parseInt(parts[0]);
            minutes += (parseInt(parts[1]) / 60)
            break;
        case 3:
            minutes += (parseInt(parts[0]) * 60);
            minutes += parseInt(parts[1]);
            minutes += (parseInt(parts[2]) / 60)
            break;

        default:
            break;
    }

    return isNaN(minutes) ? 0 : minutes;
}

export const FormatSecondsTimePicker = (time: string): number => {
    const parts = time.split(':');
    let seconds = 0;
    switch (parts.length) {
        case 1:
            seconds += parseInt(parts[0]) * 60;
            break;
        case 2:

            seconds += parseInt(parts[0]) * 60;
            seconds += parseInt(parts[1])
            break;
        case 3:

            seconds += (parseInt(parts[0]) * 60 * 60);
            seconds += (parseInt(parts[1]) * 60);
            seconds += parseInt(parts[2])
            break;

        default:
            break;
    }

    return isNaN(seconds) ? 0 : seconds;
}

export const ConversorSegundos = (valor: string): number => {
    let nuevoValor = valor.toString();

    const contieneSeparador = valor.toString().includes(':');
    if (contieneSeparador) {
      const partes = nuevoValor.split(':');
      if (partes.length === 2) {
        if (partes[1].length === 0) {
          nuevoValor = partes[0];
        }
      }
    }

    const timeSeconds = FormatSecondsTimePicker(nuevoValor);
    return timeSeconds;
}

export const FormatearMinutosSegundos = (segundos: number) : string => {
    const minutos = Math.floor(segundos / 60);
    const segundosRestantes = segundos % 60;

    const minutosString = minutos.toString().length === 1 ? `0${minutos}`: minutos.toString();
    const segundosRestantesString = segundosRestantes.toString().length === 1 ? `0${segundosRestantes}`: segundosRestantes.toString();
    const formato = minutosString + ':' + segundosRestantesString;

    return formato;
}